// Типы для переводов
export interface Translations {
    common: {
        cart: string;
        search: string;
        login: string;
        register: string;
        account: string;
        home: string;
        shop: string;
        categories: string;
        product: string;
        products: string;
        price: string;
        quantity: string;
        total: string;
        addToCart: string;
        removeFromCart: string;
        checkout: string;
        loading: string;
        error: string;
        success: string;
    };
    navigation: {
        mainMenu: string;
        catalog: string;
        about: string;
        contact: string;
        blog: string;
        support: string;
    };
    cart: {
        title: string;
        empty: string;
        itemsCount: string;
        subtotal: string;
        shipping: string;
        tax: string;
        total: string;
        proceedToCheckout: string;
        goToCart: string;
        continueShipping: string;
        removeItem: string;
        updateQuantity: string;
    };
    product: {
        details: string;
        description: string;
        specifications: string;
        allSpecifications: string;
        reviews: string;
        addToWishlist: string;
        compareProducts: string;
        shareProduct: string;
        inStock: string;
        outOfStock: string;
        availability: string;
        aboutProduct: string;
        sku: string;
    };
    forms: {
        name: string;
        email: string;
        phone: string;
        password: string;
        confirmPassword: string;
        address: string;
        city: string;
        zipCode: string;
        country: string;
        save: string;
        cancel: string;
        submit: string;
        required: string;
        invalidEmail: string;
        passwordTooShort: string;
    };
    newsletter: {
        placeholder: string;
        buttonSubmit: string;
        buttonSubmitting: string;
        title: string;
        privacyText: string;
        privacyLink: string;
        successMessage: string;
        errorMessage: string;
    };
    projectCalculation: {
        title: string;
        description: string;
        name: string;
        phone: string;
        email: string;
        message: string;
        messagePlaceholder: string;
        privacyLabel: string;
        privacyLink: string;
        marketingLabel: string;
        submitButton: string;
        submittingButton: string;
        successMessage: string;
        errorMessage: string;
    };
    footer: {
        title: string;
        subTitle: string;
        sections: {
            catalog: string;
            about: string;
            customer: string;
        };
        links: {
            delivery: string;
            faq: string;
        };
    };
}

// Переводы для английского языка
export const enTranslations: Translations = {
    common: {
        cart: 'Cart',
        search: 'Search',
        login: 'Login',
        register: 'Register',
        account: 'Account',
        home: 'Home',
        shop: 'Shop',
        categories: 'Categories',
        product: 'Product',
        products: 'Products',
        price: 'Price',
        quantity: 'Quantity',
        total: 'Total',
        addToCart: 'Add to Cart',
        removeFromCart: 'Remove from Cart',
        checkout: 'Checkout',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
    },
    navigation: {
        mainMenu: 'Main Menu',
        catalog: 'Catalog',
        about: 'About',
        contact: 'Contact',
        blog: 'Blog',
        support: 'Support',
    },
    cart: {
        title: 'Shopping Cart',
        empty: 'Your cart is empty',
        itemsCount: 'items in cart',
        subtotal: 'Subtotal',
        shipping: 'Shipping',
        tax: 'Tax',
        total: 'Total',
        proceedToCheckout: 'Proceed to Checkout',
        goToCart: 'Go to Cart',
        continueShipping: 'Continue Shopping',
        removeItem: 'Remove Item',
        updateQuantity: 'Update Quantity',
    },
    product: {
        details: 'Product Details',
        description: 'Description',
        specifications: 'Specifications',
        allSpecifications: 'All Specifications',
        reviews: 'Reviews',
        addToWishlist: 'Add to Wishlist',
        compareProducts: 'Compare Products',
        shareProduct: 'Share Product',
        inStock: 'In Stock',
        outOfStock: 'Out of Stock',
        availability: 'Availability',
        aboutProduct: 'About Product',
        sku: 'SKU',
    },
    forms: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        address: 'Address',
        city: 'City',
        zipCode: 'ZIP Code',
        country: 'Country',
        save: 'Save',
        cancel: 'Cancel',
        submit: 'Submit',
        required: 'This field is required',
        invalidEmail: 'Please enter a valid email',
        passwordTooShort: 'Password must be at least 8 characters',
    },
    newsletter: {
        placeholder: 'Enter your email',
        buttonSubmit: 'Subscribe',
        buttonSubmitting: 'Submitting...',
        title: 'Want to receive product news? Subscribe to our newsletter.',
        privacyText: 'We care about your data. Read our',
        privacyLink: 'privacy policy',
        successMessage: 'Subscription successful!',
        errorMessage: 'Error sending. Please try again.',
    },
    projectCalculation: {
        title: 'Project Calculation',
        description: 'Fill out the form and we will contact you soon to calculate the project cost.',
        name: 'Full Name',
        phone: 'Phone',
        email: 'Email',
        message: 'Message',
        messagePlaceholder: 'Describe your project or ask a question...',
        privacyLabel: 'I agree to the processing of my personal data and agree with the',
        privacyLink: 'privacy policy',
        marketingLabel: 'I agree to receive marketing communications.',
        submitButton: 'Submit Request',
        submittingButton: 'Submitting...',
        successMessage: 'Request sent successfully!',
        errorMessage: 'Error sending request. Please try again.',
    },
    footer: {
        title: 'ЗМК Континенталь',
        subTitle: 'Производство и строительство',
        sections: {
            catalog: 'Catalog',
            about: 'ЗМК Континенталь',
            customer: 'For Customers',
        },
        links: {
            delivery: 'Delivery and Payment',
            faq: 'Questions and Answers',
        },
    },
};

// Переводы для русского языка
export const ruTranslations: Translations = {
    common: {
        cart: 'Заявка',
        search: 'Поиск',
        login: 'Войти',
        register: 'Регистрация',
        account: 'Аккаунт',
        home: 'Главная',
        shop: 'Магазин',
        categories: 'Категории',
        product: 'Товар',
        products: 'Товары',
        price: 'Цена',
        quantity: 'Количество',
        total: 'Итого',
        addToCart: 'Добавить в заявку',
        removeFromCart: 'Удалить из заявки',
        checkout: 'Оформить заявку',
        loading: 'Загрузка...',
        error: 'Ошибка',
        success: 'Успешно',
    },
    navigation: {
        mainMenu: 'Главное меню',
        catalog: 'Каталог',
        about: 'О нас',
        contact: 'Контакты',
        blog: 'Блог',
        support: 'Поддержка',
    },
    cart: {
        title: 'Заявка',
        empty: 'Ваша заявка пуста',
        itemsCount: 'позиций в заявке',
        subtotal: 'Подытог',
        shipping: 'Доставка',
        tax: 'Налог',
        total: 'Итого',
        proceedToCheckout: 'Оформить заявку',
        goToCart: 'Перейти в заявку',
        continueShipping: 'Продолжить покупки',
        removeItem: 'Удалить позицию',
        updateQuantity: 'Изменить количество',
    },
    product: {
        details: 'Описание товара',
        description: 'Описание',
        specifications: 'Характеристики',
        allSpecifications: 'Все характеристики',
        reviews: 'Отзывы',
        addToWishlist: 'Сохранить',
        compareProducts: 'Сравнить товары',
        shareProduct: 'Поделиться товаром',
        inStock: 'В наличии',
        outOfStock: 'Нет в наличии',
        availability: 'Наличие',
        aboutProduct: 'О товаре',
        sku: 'Артикул',
    },
    forms: {
        name: 'Имя',
        email: 'Email',
        phone: 'Телефон',
        password: 'Пароль',
        confirmPassword: 'Подтвердите пароль',
        address: 'Адрес',
        city: 'Город',
        zipCode: 'Почтовый индекс',
        country: 'Страна',
        save: 'Сохранить',
        cancel: 'Отмена',
        submit: 'Отправить',
        required: 'Это поле обязательно',
        invalidEmail: 'Введите корректный email',
        passwordTooShort: 'Пароль должен содержать минимум 8 символов',
    },
    newsletter: {
        placeholder: 'Введите ваш email',
        buttonSubmit: 'Подписаться',
        buttonSubmitting: 'Отправка...',
        title: 'Хотите получать новости о продуктах? Подпишитесь на рассылку.',
        privacyText: 'Мы заботимся о ваших данных. Ознакомьтесь с нашей',
        privacyLink: 'политикой конфиденциальности',
        successMessage: 'Подписка оформлена успешно!',
        errorMessage: 'Ошибка при отправке. Попробуйте ещё раз.',
    },
    projectCalculation: {
        title: 'Расчёт по проекту',
        description: 'Заполните форму, и мы свяжемся с вами в ближайшее время для расчёта стоимости проекта.',
        name: 'ФИО',
        phone: 'Телефон',
        email: 'Email',
        message: 'Сообщение',
        messagePlaceholder: 'Опишите ваш проект или задайте вопрос...',
        privacyLabel: 'Я даю согласие на обработку своих персональных данных и соглашаюсь с',
        privacyLink: 'политикой конфиденциальности',
        marketingLabel: 'Я даю согласие на направление рекламных рассылок.',
        submitButton: 'Отправить заявку',
        submittingButton: 'Отправка...',
        successMessage: 'Заявка успешно отправлена!',
        errorMessage: 'Ошибка при отправке заявки. Попробуйте ещё раз.',
    },
    footer: {
        title: 'ЗМК Континенталь',
        subTitle: 'Производство и строительство',
        sections: {
            catalog: 'Каталог',
            about: 'ЗМК Континенталь',
            customer: 'Покупателям',
        },
        links: {
            delivery: 'Доставка и оплата',
            faq: 'Вопросы и ответы',
        },
    },
};

// Переводы для немецкого языка
export const deTranslations: Translations = {
    common: {
        cart: 'Warenkorb',
        search: 'Suchen',
        login: 'Anmelden',
        register: 'Registrieren',
        account: 'Konto',
        home: 'Startseite',
        shop: 'Shop',
        categories: 'Kategorien',
        product: 'Produkt',
        products: 'Produkte',
        price: 'Preis',
        quantity: 'Menge',
        total: 'Gesamt',
        addToCart: 'In den Warenkorb',
        removeFromCart: 'Aus Warenkorb entfernen',
        checkout: 'Zur Kasse',
        loading: 'Laden...',
        error: 'Fehler',
        success: 'Erfolgreich',
    },
    navigation: {
        mainMenu: 'Hauptmenü',
        catalog: 'Katalog',
        about: 'Über uns',
        contact: 'Kontakt',
        blog: 'Blog',
        support: 'Support',
    },
    cart: {
        title: 'Einkaufswagen',
        empty: 'Ihr Warenkorb ist leer',
        itemsCount: 'Artikel im Warenkorb',
        subtotal: 'Zwischensumme',
        shipping: 'Versand',
        tax: 'Steuer',
        total: 'Gesamt',
        proceedToCheckout: 'Zur Kasse gehen',
        goToCart: 'Zum Warenkorb',
        continueShipping: 'Weiter einkaufen',
        removeItem: 'Artikel entfernen',
        updateQuantity: 'Menge aktualisieren',
    },
    product: {
        details: 'Produktdetails',
        description: 'Beschreibung',
        specifications: 'Spezifikationen',
        allSpecifications: 'Alle Spezifikationen',
        reviews: 'Bewertungen',
        addToWishlist: 'Zur Wunschliste hinzufügen',
        compareProducts: 'Produkte vergleichen',
        shareProduct: 'Produkt teilen',
        inStock: 'Auf Lager',
        outOfStock: 'Nicht verfügbar',
        availability: 'Verfügbarkeit',
        aboutProduct: 'Über das Produkt',
        sku: 'Artikelnummer',
    },
    forms: {
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        address: 'Adresse',
        city: 'Stadt',
        zipCode: 'Postleitzahl',
        country: 'Land',
        save: 'Speichern',
        cancel: 'Abbrechen',
        submit: 'Senden',
        required: 'Dieses Feld ist erforderlich',
        invalidEmail: 'Bitte geben Sie eine gültige E-Mail ein',
        passwordTooShort: 'Passwort muss mindestens 8 Zeichen lang sein',
    },
    newsletter: {
        placeholder: 'Geben Sie Ihre E-Mail ein',
        buttonSubmit: 'Abonnieren',
        buttonSubmitting: 'Wird gesendet...',
        title: 'Möchten Sie Produktneuigkeiten erhalten? Abonnieren Sie unseren Newsletter.',
        privacyText: 'Wir kümmern uns um Ihre Daten. Lesen Sie unsere',
        privacyLink: 'Datenschutzrichtlinie',
        successMessage: 'Abonnierung erfolgreich!',
        errorMessage: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
    },
    projectCalculation: {
        title: 'Projektberechnung',
        description: 'Füllen Sie das Formular aus und wir werden uns bald mit Ihnen in Verbindung setzen, um die Projektkosten zu berechnen.',
        name: 'Vollständiger Name',
        phone: 'Telefon',
        email: 'E-Mail',
        message: 'Nachricht',
        messagePlaceholder: 'Beschreiben Sie Ihr Projekt oder stellen Sie eine Frage...',
        privacyLabel: 'Ich stimme der Verarbeitung meiner persönlichen Daten zu und stimme der',
        privacyLink: 'Datenschutzrichtlinie',
        marketingLabel: 'Ich stimme dem Erhalt von Marketing-Kommunikation zu.',
        submitButton: 'Anfrage senden',
        submittingButton: 'Wird gesendet...',
        successMessage: 'Anfrage erfolgreich gesendet!',
        errorMessage: 'Fehler beim Senden der Anfrage. Bitte versuchen Sie es erneut.',
    },
    footer: {
        title: 'WGP Shop',
        subTitle: 'Professionelle E-Commerce-Lösungen und Webentwicklungsdienste',
        sections: {
            catalog: 'Katalog',
            about: 'WGP Shop',
            customer: 'Für Kunden',
        },
        links: {
            delivery: 'Versand und Zahlung',
            faq: 'Fragen und Antworten',
        },
    },
};

// Коллекция всех переводов
export const translations = {
    en: enTranslations,
    ru: ruTranslations,
    de: deTranslations,
} as const;

// Функция для получения переводов по языку
export function getTranslations(languageCode: string): Translations {
    // Используем синхронный загрузчик для клиентских компонентов
    try {
        const { getTranslationsSync } = require('./translationsLoader')
        return getTranslationsSync(languageCode)
    } catch (error) {
        // Fallback к статическим переводам
        return translations[languageCode as keyof typeof translations] || translations.en;
    }
} 
